module.exports = __webpack_public_path__ + "img/directions.dd0aed2a.svg";